export default __webpack_public_path__ + "static/media/fractal.f4c92ba4.jpg";